import { Map } from "immutable"

import {
    KNOWLEDGE_LIST_REQUEST as LIST_REQUEST,
    KNOWLEDGE_LIST_RESPONSE as LIST_RESPONSE,
    KNOWLEDGE_LIST_CACHED_RESPONSE as LIST_CACHED_RESPONSE,
    KNOWLEDGE_LIST_ERROR_RESPONSE as LIST_ERROR_RESPONSE,
    KNOWLEDGE_ANALYSE_REQUEST
} from "../../actions/action-types"
import buildPagingReducer from "./build-paging-reducer"
import { serialiseSearchCriteria } from "./paging-reducer-utils"

const defaultSearchCriteria = Map({
    title: ""
})

const defaultState = {
    [serialiseSearchCriteria(defaultSearchCriteria)]: {
        searchCriteria: defaultSearchCriteria
    }
}

const defaultReducer = buildPagingReducer(
    {
        LIST_REQUEST,
        LIST_RESPONSE,
        LIST_CACHED_RESPONSE,
        LIST_ERROR_RESPONSE
    },
    defaultSearchCriteria,
    defaultState
)

export default (state = undefined, action) => {
    const defaultReduction = defaultReducer(state, action)
    switch (action.type) {
        case KNOWLEDGE_ANALYSE_REQUEST:
            return defaultState
        default:
            return defaultReduction
    }
}
